var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-[10px] px-[12px] cursor-pointer hover:bg-gray-100 transition"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }